/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PaginatedBareLogsResponseDto,
} from '../models/index';
import {
    PaginatedBareLogsResponseDtoFromJSON,
    PaginatedBareLogsResponseDtoToJSON,
} from '../models/index';

export interface AssetBareLogsExportControllerExportAssetLogsRequest {
    to: string;
    from: string;
    assetId: string;
    organizationId: string;
}

export interface AssetBareLogsExportControllerPreviewAssetLogsRequest {
    to: string;
    from: string;
    assetId: string;
    organizationId: string;
    limit?: number;
    page?: number;
}

/**
 * 
 */
export class AssetLogsExportApi extends runtime.BaseAPI {

    /**
     * Download bare asset logs as a JSON array (SUPER_ADMIN only)
     */
    async assetBareLogsExportControllerExportAssetLogsRaw(requestParameters: AssetBareLogsExportControllerExportAssetLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['to'] == null) {
            throw new runtime.RequiredError(
                'to',
                'Required parameter "to" was null or undefined when calling assetBareLogsExportControllerExportAssetLogs().'
            );
        }

        if (requestParameters['from'] == null) {
            throw new runtime.RequiredError(
                'from',
                'Required parameter "from" was null or undefined when calling assetBareLogsExportControllerExportAssetLogs().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetBareLogsExportControllerExportAssetLogs().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetBareLogsExportControllerExportAssetLogs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['to'] != null) {
            queryParameters['to'] = requestParameters['to'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/logs/export`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Download bare asset logs as a JSON array (SUPER_ADMIN only)
     */
    async assetBareLogsExportControllerExportAssetLogs(requestParameters: AssetBareLogsExportControllerExportAssetLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetBareLogsExportControllerExportAssetLogsRaw(requestParameters, initOverrides);
    }

    /**
     * Preview bare asset logs paginated (SUPER_ADMIN only)
     */
    async assetBareLogsExportControllerPreviewAssetLogsRaw(requestParameters: AssetBareLogsExportControllerPreviewAssetLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedBareLogsResponseDto>> {
        if (requestParameters['to'] == null) {
            throw new runtime.RequiredError(
                'to',
                'Required parameter "to" was null or undefined when calling assetBareLogsExportControllerPreviewAssetLogs().'
            );
        }

        if (requestParameters['from'] == null) {
            throw new runtime.RequiredError(
                'from',
                'Required parameter "from" was null or undefined when calling assetBareLogsExportControllerPreviewAssetLogs().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetBareLogsExportControllerPreviewAssetLogs().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetBareLogsExportControllerPreviewAssetLogs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['to'] != null) {
            queryParameters['to'] = requestParameters['to'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/logs/bare`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedBareLogsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Preview bare asset logs paginated (SUPER_ADMIN only)
     */
    async assetBareLogsExportControllerPreviewAssetLogs(requestParameters: AssetBareLogsExportControllerPreviewAssetLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedBareLogsResponseDto> {
        const response = await this.assetBareLogsExportControllerPreviewAssetLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
